/**
 * Identifies the class or source of DeliveryStreamDeliveryPoint(41062).
 * tag: 42192
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryStreamDeliveryPointSource {
  /** Proprietary */
  Proprietary = 0,
  EIC = 1,
}
